/* =============================================================================
 * puff-gallery-filter.js  —  Owala-style variant gallery for the Impact theme
 * -----------------------------------------------------------------------------
 * Selecting (or hovering) a variant shows only the matching shots — filtered by
 * SIZE + COLOR + FINISH — with graceful fallbacks, plus an Owala-style bottom
 * nav bar (arrows + dots) that scrolls through just that variant's shots.
 *
 *  • Reads /products/{handle}.js at runtime — nothing baked in; self-updates.
 *  • Groups images by base filename number (I-00000186396-1/-2/-3/-4 = same
 *    photoshoot, four angles) and reads each shoot's size/color/finish from the
 *    variant it's assigned to, so angle shots inherit all three automatically.
 *  • Hover a color swatch = live preview (keeps the current size + finish).
 *  • Fallback order keeps the match as close as possible, colour always correct:
 *      size+color+finish → size+color+Matte → size+color →
 *      color+finish → color+Matte → color.
 *  • Never blanks the gallery: an unmapped colour shows everything.
 *  • Hides Impact's overlay arrows + thumbnail strip in favour of the dot bar.
 *
 * INSTALL (once):
 *   1. Online Store → Themes → your theme → ⋯ → Edit code
 *   2. Assets → "puff-gallery-filter.js" → paste this file.
 *   3. Layout → theme.liquid → before </head>:
 *        <script src="{{ 'puff-gallery-filter.js' | asset_url }}" defer></script>
 *   4. Save.
 *
 *  Keep Impact's thumbnail strip instead of the dots? Set HIDE_THUMBS = false.
 * ========================================================================== */
(function () {
  "use strict";

  var HIDE_THUMBS = true;
  var ACCENT = "#1e1b4b";

  function boot() { try { run(); } catch (e) { if (window.console) console.warn("[puff-gallery]", e); } }

  async function run() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    var g = document.querySelector("product-gallery");
    if (!g) return;

    var H = function (s) { return (s || "").toLowerCase().trim().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, ""); };
    var baseOf = function (s) {
      var f = (s || "").split("/").pop().split("?")[0].replace(/\.[a-z0-9]+$/i, "");
      var mm = f.match(/^(I-\d+)/i); return mm ? mm[1].toUpperCase() : null;
    };

    var p = await fetch("/products/" + m[1] + ".js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });

    var names = p.options.map(function (o) { return o.name; });
    var si = names.findIndex(function (n) { return /size/i.test(n); });
    var ci = names.findIndex(function (n) { return /colou?r/i.test(n); });
    var fi = names.findIndex(function (n) { return /finish|material/i.test(n); });
    if (ci < 0) return;
    var sizeVals = si >= 0 ? p.options[si].values : [];
    var colorVals = p.options[ci].values;
    var finishVals = fi >= 0 ? p.options[fi].values : [];
    var norm = function (t, arr) { return arr.find(function (k) { return H(k) === H(t); }) || arr.find(function (k) { return (t || "").indexOf(k) > -1; }) || null; };

    // base -> {size, color, finish} from variant featured images
    var baseCF = {};
    p.variants.forEach(function (v) {
      if (!v.featured_image) return;
      var b = baseOf(v.featured_image.src); if (!b || baseCF[b]) return;
      if (v.options[ci]) baseCF[b] = { size: si >= 0 ? v.options[si] : null, color: v.options[ci], finish: fi >= 0 ? v.options[fi] : null };
    });

    // group ALL media by base into progressively looser buckets (for fallback)
    var scf = {}, sc = {}, cf = {}, col = {};
    p.media.forEach(function (media) {
      var b = baseOf(media.src), c = b ? baseCF[b] : null; if (!c) return;
      var id = String(media.id);
      if (c.size != null && c.finish != null) (scf[c.size + "|" + c.color + "|" + c.finish] = scf[c.size + "|" + c.color + "|" + c.finish] || new Set()).add(id);
      if (c.size != null) (sc[c.size + "|" + c.color] = sc[c.size + "|" + c.color] || new Set()).add(id);
      if (c.finish != null) (cf[c.color + "|" + c.finish] = cf[c.color + "|" + c.finish] || new Set()).add(id);
      (col[c.color] = col[c.color] || new Set()).add(id);
    });
/* PUFF: shared shots — for products tagged "gallery-shared-shots", a shot number (e.g. -4) that only exists on one size is also shown for the other sizes of the same colour */
if((p.tags||[]).indexOf("gallery-shared-shots")>-1){(function(){var ang=function(s){var f=(s||"").split("/").pop().split("?")[0].replace(/\.[a-z0-9]+$/i,"").replace(/_[0-9a-f-]{36}$/i,"");var m=f.match(/-(\d+)$/);return m?m[1]:null},info={};p.media.forEach(function(md){var b=baseOf(md.src),c=b?baseCF[b]:null,n=ang(md.src);if(c&&n)info[String(md.id)]={c:c,n:n}});function fill(map,match){Object.keys(map).forEach(function(k){var have={};map[k].forEach(function(id){if(info[id])have[info[id].n]=1});Object.keys(info).forEach(function(id){var x=info[id];if(match(k,x.c)&&!have[x.n]){map[k].add(id);have[x.n]=1}})})}fill(sc,function(k,c){return k.split("|")[1]===c.color});fill(scf,function(k,c){var q=k.split("|");return q[1]===c.color&&q[2]===c.finish})})()}
    var variantMap = {};
    p.variants.forEach(function (v) { variantMap[v.id] = { size: si >= 0 ? v.options[si] : null, color: v.options[ci], finish: fi >= 0 ? v.options[fi] : null }; });

    function resolve(size, color, finish) {
      var x =
        (size != null && finish != null && scf[size + "|" + color + "|" + finish]) ||
        (size != null && scf[size + "|" + color + "|Matte"]) ||
        (size != null && sc[size + "|" + color]) ||
        (finish != null && cf[color + "|" + finish]) ||
        cf[color + "|Matte"] ||
        col[color];
      return x ? new Set(Array.from(x)) : new Set();
    }
    function currentSelection() {
      var idInput = document.querySelector('form[id^="product-form"] [name="id"]');
      if (idInput && variantMap[idInput.value]) return variantMap[idInput.value];
      function lab(idx) {
        if (idx < 0) return null;
        var r = document.querySelector('input[name$="-option' + (idx + 1) + '"]:checked'); if (!r) return null;
        var l = document.querySelector('label[for="' + r.id + '"]') || r.closest("label"); return l ? l.textContent : null;
      }
      return { size: si >= 0 ? norm(lab(si), sizeVals) : null, color: norm(lab(ci), colorVals), finish: fi >= 0 ? norm(lab(fi), finishVals) : null };
    }

    // ---- gallery refs ------------------------------------------------------
    var scroller = g.querySelector("media-carousel") || g.querySelector(".product-gallery__media-list");
    function mediaEls() { return Array.prototype.slice.call(g.querySelectorAll(".product-gallery__media")); }
    function thumbEls() { return Array.prototype.slice.call(g.querySelectorAll('[class*="thumbnail"][data-media-id]')); }
    function visible() { return mediaEls().filter(function (e) { return e.style.display !== "none"; }); }

    var thumbWrap = g.querySelector(".product-gallery__thumbnail-list-wrapper");
    if (HIDE_THUMBS && thumbWrap) thumbWrap.style.display = "none";
    g.querySelectorAll(".circle-button--fill.ring").forEach(function (b) { b.style.display = "none"; });

    // ---- nav bar (idempotent) ---------------------------------------------
    var nav = g.querySelector(".puff-nav");
    if (!nav) {
      nav = document.createElement("div");
      nav.className = "puff-nav";
      nav.style.cssText = "display:flex;align-items:center;justify-content:center;gap:14px;margin:14px auto 4px;user-select:none";
      var ac = "background:none;border:none;cursor:pointer;font-size:22px;line-height:1;color:" + ACCENT + ";padding:6px 10px;border-radius:50%;opacity:.85";
      nav.innerHTML =
        '<button class="puff-arrow" data-d="-1" aria-label="Previous" style="' + ac + '">\u2039</button>' +
        '<div class="puff-dots" style="display:flex;align-items:center;flex-wrap:wrap;justify-content:center;gap:9px;max-width:60%"></div>' +
        '<button class="puff-arrow" data-d="1" aria-label="Next" style="' + ac + '">\u203a</button>';
      var ar = g.querySelector(".product-gallery__ar-wrapper") || scroller;
      if (ar && ar.parentNode) ar.parentNode.insertBefore(nav, ar.nextSibling); else g.appendChild(nav);
    }
    var dotsWrap = nav.querySelector(".puff-dots");

    function goTo(el) { if (el) el.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" }); }
    function activeIndex() {
      var vis = visible(); if (!vis.length || !scroller) return 0;
      var center = scroller.scrollLeft + scroller.clientWidth / 2, best = 0, bd = Infinity;
      vis.forEach(function (el, i) { var c = el.offsetLeft + el.offsetWidth / 2, d = Math.abs(c - center); if (d < bd) { bd = d; best = i; } });
      return best;
    }
    function paintDots() {
      var vis = visible();
      nav.style.display = vis.length > 1 ? "flex" : "none";
      var act = activeIndex();
      dotsWrap.innerHTML = "";
      vis.forEach(function (el, i) {
        var d = document.createElement("button");
        d.setAttribute("aria-label", "Go to shot " + (i + 1));
        d.style.cssText = "width:9px;height:9px;border-radius:50%;border:none;cursor:pointer;padding:0;transition:all .2s;background:" +
          (i === act ? ACCENT : "rgba(30,27,75,.28)") + ";transform:scale(" + (i === act ? 1.15 : 1) + ")";
        d.addEventListener("click", function () { goTo(visible()[i]); });
        dotsWrap.appendChild(d);
      });
    }
    function updateActive() {
      var act = activeIndex();
      Array.prototype.forEach.call(dotsWrap.children, function (d, i) {
        d.style.background = i === act ? ACCENT : "rgba(30,27,75,.28)";
        d.style.transform = "scale(" + (i === act ? 1.15 : 1) + ")";
      });
    }
    nav.querySelectorAll(".puff-arrow").forEach(function (b) {
      b.addEventListener("click", function () {
        var vis = visible(); if (!vis.length) return;
        var i = Math.max(0, Math.min(vis.length - 1, activeIndex() + parseInt(b.dataset.d, 10)));
        goTo(vis[i]);
      });
    });
    if (scroller) { var raf; scroller.addEventListener("scroll", function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(updateActive); }, { passive: true }); }

    // ---- paint -------------------------------------------------------------
    function paint(ids) {
      if (!ids || !ids.size) {
        mediaEls().forEach(function (e) { e.style.display = ""; });
        thumbEls().forEach(function (e) { e.style.display = ""; });
      } else {
        var first = null;
        mediaEls().forEach(function (el) { var mm = ids.has(String(el.dataset.mediaId)); el.style.display = mm ? "" : "none"; if (mm && !first) first = el; });
        thumbEls().forEach(function (el) { var mid = String(el.dataset.mediaId || ""); if (mid) el.style.display = ids.has(mid) ? "" : "none"; });
        if (first) first.scrollIntoView({ inline: "center", block: "nearest" });
      }
      paintDots();
    }
    function applyCommitted() { var s = currentSelection(); if (s.color) paint(resolve(s.size, s.color, s.finish)); }
    function previewColor(color) { var s = currentSelection(); paint(resolve(s.size, color, s.finish)); }

    // ---- hover on color swatches (delegated) ------------------------------
    function swatchColor(label) {
      var inp = label.control || (label.htmlFor && document.getElementById(label.htmlFor));
      if (!inp || !new RegExp("-option" + (ci + 1) + "$").test(inp.name || "")) return null;
      return norm(label.textContent, colorVals);
    }
    var revertT = null;
    document.addEventListener("mouseover", function (e) {
      var l = e.target.closest && e.target.closest("label"); if (!l) return;
      var c = swatchColor(l); if (!c) return; clearTimeout(revertT); previewColor(c);
    });
    document.addEventListener("mouseout", function (e) {
      var l = e.target.closest && e.target.closest("label"); if (!l || !swatchColor(l)) return;
      revertT = setTimeout(applyCommitted, 120);
    });

    // re-apply after variant change (twice — beats the theme's async re-render)
    document.addEventListener("change", function () { setTimeout(applyCommitted, 60); setTimeout(applyCommitted, 300); }, true);
    if (window.MutationObserver) {
      new MutationObserver(function () { setTimeout(applyCommitted, 30); })
        .observe(g, { attributes: true, subtree: true, attributeFilter: ["filtered-indexes"] });
    }

    applyCommitted();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();